import {
  getEventsFromHistoryApi,
  getEventsPracticeFullhandApi,
  getEventsPracticeBotApi,
  getEventsShowdownApi,
  getHistoryUrlParams,
  getEventsPracticeSpecificSpotApi,
  setHsBot,
} from '@/store/gamestate/gamestate'
import { namespaces } from '@/helpers/constants'

import { getGameformat } from '@/store/gameformat/gameformat'
import { sleep } from '@/helpers/helpers'

const heroActionTracked = {}

function stopGame(getters, id) {
  if (!getters.trainer_practice_hand_id) return true
  return getters.trainer_practice_hand_id !== id
}

const actions = {
  gamestate_set_practice_setup({ state, getters, rootGetters, commit, dispatch }, result) {
    if (rootGetters.hands_configure) return

    if (result?.response?.status !== 200) {
      dispatch(
        `hands_handle_error`,
        { handler: 'setup', result, namespace: state.gamestate_namespace },
        { root: true },
      )
    } else {
      const {
        id,
        board,
        hand,
        opponent_positions,
        hero_position,
        history_actions,
        solution_properties,
        shortcut,
        custom_tree,
        custom_solution_id,
      } = result.response?.data
      const { namespace } = result
      const { playFromHere } = result

      const callParams = result.callParams?.params
      if (callParams?.is_competitive === false) {
        // default is true, so send only is_competitive:false
        dispatch('trainer_set_cheats_reqistered', { namespace, value: true })
      }

      if (!id) {
        console.error('error-trainer --SETUP-HAND-ID--', id, JSON.stringify({ callParams }))
        dispatch(
          `hands_handle_error`,
          { handler: 'setup-hand-id', result, namespace: state.gamestate_namespace },
          { root: true },
        )
        return
      }
      // debugger
      commit('trainer_set', { key: 'trainer_error', value: null })
      // commit('trainer_set', { key: 'trainer_live', value: true })
      commit('trainer_set', { key: 'trainer_practice_hand_id', value: id })

      // let game_properties = {
      //   format: 'Cash',
      //   variant: `mock---NL Hold'em---mock`,
      //   default_players: 6,
      // }
      const game_properties = solution_properties?.game_properties
      commit('trainer_set', { key: 'trainer_api_game_properties', value: game_properties })

      if (playFromHere) {
        const { hSpots, query } = playFromHere
        commit(`gamestate_set`, {
          key: 'history_spots',
          value: hSpots,
        })
        dispatch(`trainer_router_update_query`, {
          query,
          push: false,
          replace: false,
          saveLocally: false,
        })
        const currentSpot = hSpots[hSpots.length - 1]
        const active_position = currentSpot.position
        if (active_position === hero_position) {
          dispatch('gamestate_get_hero_actions', {
            namespace,
            history_spot: currentSpot,
            // gamestateNext: false,
          })
        } else {
          dispatch('gamestate_get_bot_action', {
            namespace,
            position: active_position,
            history_spot: currentSpot,
          })
        }

        const { originalSettingsHand } = playFromHere
        commit('trainer_set', {
          key: 'trainer_hand_settings',
          value: JSON.stringify(originalSettingsHand),
        })
        // console.log(originalSettingsHand)
        // debugger
        return
      }

      let gameformatQuery = null
      const usingCustomSolution = !!custom_solution_id

      if (usingCustomSolution) {
        gameformatQuery = {
          custom_solution_id,
          custom_tree_id: custom_tree.id,
        }
        // let customTree = custom_tree
        const trimmedTree = {
          id: custom_tree.id,
          pot: custom_tree.pot,
          // tree_operations
          // starting_street
          // bet_sizes
          players: custom_tree.players.map(i => ({
            display_position: i.display_position,
            position: i.position,
            stack: i.stack,
            // range,
          })),
        }
        commit('trainer_set', { key: 'trainer_custom_tree', value: trimmedTree })
      } else {
        const { gameformats } = rootGetters
        const gameformat = getGameformat({ item: solution_properties, gameformats })
        if (!gameformat) {
          console.error('error-trainer --SETUP-GMF--', JSON.stringify({ solution_properties }))
          dispatch(
            `hands_handle_error`,
            { handler: 'setup-gmf', result, namespace: state.gamestate_namespace },
            { root: true },
          )
          return
        }
        gameformatQuery = {
          stacks: gameformat.stacks,
          gametype: gameformat.gametype,
          depth: gameformat.depth,
        }
      }

      const repeatParams = {
        ...gameformatQuery,
        board,
        hand,
        opponent_positions: opponent_positions || [],
        hero_positions: [hero_position],
        ...(shortcut ? { shortcut_id: shortcut.id } : {}), // represents unique game-tree
        ...(shortcut ? { label_id: shortcut.label.id } : {}), // represent situation (game-trees can vary) - ignored if shortcut_id is present
        ...(callParams.preflop_actions ? { preflop_actions: callParams.preflop_actions } : {}),
        ...(callParams.flop_actions ? { flop_actions: callParams.flop_actions } : {}),
        ...(callParams.turn_actions ? { turn_actions: callParams.turn_actions } : {}),
        ...(callParams.river_actions ? { river_actions: callParams.river_actions } : {}),
      }
      commit('trainer_set', { key: 'trainer_setup_repeat_params', value: repeatParams })

      let opPosition = (shortcut?.label.positions || []).filter(p => p !== hero_position)[0] || ''
      if (!opPosition && opponent_positions?.length) {
        const opPositions = opponent_positions.filter(p => p !== hero_position)
        opPosition = opPositions[Math.floor(Math.random() * opPositions.length)]
      }

      let setupQuery = {
        ...gameformatQuery,
        // fh_hero: callParams.hero_positions,
        fh_opponent_tmp: opPosition,
        fh_hero_tmp: hero_position,
        hand_tmp: hand,
        board_tmp: board,
        fh_action_tmp: shortcut?.label?.type || '',
        fh_rel_position_tmp: callParams.relative_hero_position || '',
      }

      // console.log(repeatParams, setupQuery)
      // debugger

      let { history_spots } = getEventsFromHistoryApi({
        future_spots: [],
        history_spots: history_actions,
        custom_solution_id,
      })
      history_spots = setHsBot({ history_spots, hero_position })

      const hp = getHistoryUrlParams({ history_spots })
      const hSpot = history_spots.length - 1

      setupQuery = {
        ...setupQuery,
      }

      dispatch('trainer_gamestate_set_history', {
        history_spots,
        spot_id: hSpot,
        query: {
          ...setupQuery,
          ...hp,
        },
        push: false,
      })

      const lastAction = history_actions[hSpot]
      const active_position = lastAction?.game?.active_position
      const currentSpot = history_spots[hSpot]
      if (active_position === hero_position) {
        dispatch('gamestate_get_hero_actions', {
          namespace,
          history_spot: currentSpot,
        })
      } else {
        dispatch('gamestate_get_bot_action', {
          namespace,
          position: active_position,
          history_spot: currentSpot,
        })
      }
    }
  },
  gamestate_set_api_practice({ state, getters, commit, dispatch }, result) {
    const namespace = state.gamestate_namespace

    if (result?.response?.status !== 200) {
      dispatch(`hands_handle_error`, { handler: 'practice', result, namespace }, { root: true })
    } else {
      // if (result.trainer_practice_hand_id !== getters.trainer_practice_hand_id) {
      if (stopGame(getters, result.trainer_practice_hand_id)) {
        console.log('killed gamestate_set_api_practice handIdmismatch')
        dispatch('gamestate_reset_next')
        return
      }

      const data = result.response?.data
      const { query_fullhand_setup } = getters
      const qqfh = query_fullhand_setup
      const hero_position = qqfh.fh_hero_tmp

      if (data?.warning) {
        dispatch('messages_custom', { id: 'message_zero_frequency_line' }, { root: true })
      }

      let { history_spots } = getEventsPracticeFullhandApi({
        api_practice: data,
        history_spots: state.history_spots,
      })

      const spotId = history_spots.length - 1
      dispatch('trainer_gamestate_set_history', {
        history_spots,
        spot_id: spotId,
        push: false,
      })

      dispatch('gamestate_reset_next')
      if (qqfh.fh_trainer_timebank) {
        dispatch('trainer_set_timebank', {
          position: hero_position,
          timeout_str: qqfh.fh_trainer_timebank,
        })
      }
    }
  },
  async gamestate_set_api_practice_bot_action({ state, getters, commit, dispatch }, result) {
    const namespace = state.gamestate_namespace
    if (result?.response?.status !== 200) {
      dispatch(`hands_handle_error`, { handler: 'practice_bot', result, namespace }, { root: true })
    } else {
      // if (result.trainer_practice_hand_id !== getters.trainer_practice_hand_id) {
      if (stopGame(getters, result.trainer_practice_hand_id)) {
        console.log('killed gamestate_set_api_practice_bot_action handIdmismatch')
        dispatch('gamestate_reset_next')
        return
      }

      const data = result.response?.data

      const qqfh = getters.query_fullhand_setup
      const hero_position = qqfh.fh_hero_tmp
      const stopEndOfStreet = qqfh.fh_trainer_mode === 'stop_end_of_street'

      // no getter used for this
      const animDelay = getters.trainer_anim_delay

      const { history_spots, history_spot } = getEventsPracticeBotApi({
        api_practice_bot: data,
        history_spots: state.history_spots,
      })

      const spotId = history_spots.length - 1

      const { callTimeConf } = result
      const ms = callTimeConf.startTime + animDelay - Date.now()
      await sleep(ms)
      dispatch('trainer_gamestate_set_history', {
        history_spots,
        spot_id: spotId,
        push: false,
      })

      const aaOutcome = history_spot.selected_action_outcome
      dispatch('gamestate_reset_next')

      if (aaOutcome === 'showdown') {
        dispatch('gamestate_get_api_practice_showdown', { namespace, animate: true })
        return
      }
      if (stopEndOfStreet && aaOutcome === 'board') {
        const hSpots = getters.history_spots
        hSpots[hSpots.length - 1].selected_action_outcome = 'showdown'
        commit('gamestate_set', { key: 'history_spots', value: hSpots })
        dispatch('gamestate_get_api_practice_showdown', { namespace, animate: true })
        return
      }

      const action = history_spot.available_actions.find(a => a.is_selected)
      if (hero_position === action.next_position) {
        dispatch('gamestate_get_hero_actions', { namespace, action })
      } else {
        dispatch('gamestate_get_bot_action', { namespace, action, position: action.next_position })
      }
    }
  },
  gamestate_set_api_practice_showdown({ state, getters, commit, dispatch }, result) {
    const namespace = state.gamestate_namespace
    if (result?.response?.status !== 200) {
      dispatch(`hands_handle_error`, { handler: 'showdown', result, namespace }, { root: true })
    } else {
      // if (result.trainer_practice_hand_id !== getters.trainer_practice_hand_id) {
      if (stopGame(getters, result.trainer_practice_hand_id)) {
        console.log('killed gamestate_set_api_practice_showdown handIdmismatch')
        dispatch('gamestate_reset_next')
        return
      }

      const { hand, game, custom_solution_id } = result.response?.data
      const hSpots = getEventsShowdownApi({
        game,
        history_spots: state.history_spots,
        custom_solution_id,
      })
      // debugger
      const hSpot = hSpots.length - 1
      dispatch('trainer_gamestate_set_history', {
        history_spots: hSpots,
        spot_id: hSpot,
        query: {
          hand_op_tmp: hand || '',
        },
        push: false,
      })
      dispatch('trainer_hand_finish')
    }
  },

  // ------------------------------------------------------------
  gamestate_get_api_practice_showdown(
    { state, getters, commit, dispatch },
    { namespace, animate },
  ) {
    dispatch('gamestate_reset_next')

    const { history_spot } = getters
    const continueFn = () => {
      dispatch('api_practice_showdown', { namespace }, { root: true })
    }
    dispatch('gamestate_animate_and_continue', {
      continueFn,
      showdownChipsToPot: animate,
      history_spot,
    })
  },
  gamestate_set_api_practice_action_tracking({ state, getters, commit, dispatch }, result) {
    const action = result?.action
    const namespace = result?.namespace || state.gamestate_namespace
    if (result?.response?.status !== 200) {
      dispatch(
        `hands_handle_error`,
        { handler: 'action-tracking', result, namespace: state.gamestate_namespace },
        { root: true },
      )
      heroActionTracked[namespace] = {
        action,
        status: 'error',
      }
    } else {
      heroActionTracked[namespace] = {
        action,
        status: 'tracked',
      }
    }
  },
  gamestate_track_action({ state, getters, commit, dispatch }, { namespace, action }) {
    heroActionTracked[namespace] = {
      action,
      status: 'tracking',
    }
    // first register selected action and only continue after succesfull call
    if (!action.practice_action_id) {
      // call for action id, if its missing so it can be tracked
      // choose flop shortcut >> click preflop hero spot >> fetched via api_practice_silent >> click action (has no id) >> refetch to get practice_action_id >> track action
      // console.log('calling for before action track action-practice-id')
      dispatch(
        'api_practice_silent',
        { namespace, actionWithoutPracticeId: action },
        { root: true },
      )
      return
    }
    // console.log('start action-tracking')
    dispatch('api_practice_action_tracking', { namespace, action }, { root: true })
  },

  gamestate_animate_and_continue(
    { state, getters, commit, dispatch },
    { continueFn, isHero = false, history_spot, showdownChipsToPot = false },
  ) {
    const hSpot = history_spot || getters.history_spot

    commit('gamestate_set', { key: 'gamestate_next_player', value: true })
    dispatch('anim_player_action', { history_spot: hSpot, hasSounds: true })

    const action = (hSpot?.available_actions || []).find(a => a.is_selected)
    const outcome = hSpot?.selected_action_outcome // can differ from action.outcome (in gametype-street showdown)
    // console.log(outcome)
    if (outcome !== 'showdown') {
      const position = action?.next_position || hSpot.position
      const animConf = {
        position,
        extra_spot: !!action,
        history_spot: hSpot?.id,
        halo: !isHero,
        is_bot: !isHero,
        waiting: true,
        timebank: null,
      }
      commit('player_animation', animConf)
    }

    if (showdownChipsToPot && outcome === 'showdown') {
      commit(
        'api_update',
        {
          namespace: state.gamestate_namespace,
          key: 'api_practice_showdown',
          result: { loading: true, response: null, error: null, loaded: false },
          replace: true,
        },
        { root: true },
      )

      const chipsToPotDelay = ['CHECK', 'FOLD'].includes(action?.type) ? 220 : 360
      setTimeout(() => {
        dispatch('gamestate_chips_to_pot', { history_spot: hSpot })
      }, chipsToPotDelay)
      setTimeout(() => {
        commit('gamestate_set', { key: 'gamestate_next_pot', value: true })
        continueFn()
      }, chipsToPotDelay + 160)
      // }, chipsToPotDelay + 3333)
      return
    }
    if (outcome === 'board') {
      const chipsToPotDelay = ['CHECK', 'FOLD'].includes(action?.type) ? 220 : 360
      setTimeout(() => {
        dispatch('gamestate_chips_to_pot', { history_spot: hSpot })
      }, chipsToPotDelay)
      setTimeout(() => {
        commit('gamestate_set', { key: 'gamestate_next_pot', value: true })
      }, chipsToPotDelay + 160)
      setTimeout(() => {
        // debugger
        commit('gamestate_set', { key: 'gamestate_next_board', value: true })
      }, chipsToPotDelay + 260)
      setTimeout(() => {
        continueFn()
      }, chipsToPotDelay + 460)
      return
    }

    commit('gamestate_set', { key: 'gamestate_next_pot', value: true })
    continueFn()
  },
  gamestate_chips_to_pot({ state, getters, commit, dispatch }, { history_spot }) {
    const chipsOntable = (history_spot?.players || []).some(
      p => p.next_chips_on_table || p.chips_on_table,
    )
    if (chipsOntable) {
      dispatch('sounds_play', 'sound_chips_to_pot', { root: true })
      commit('gamestate_set', { key: 'gamestate_betinpot', value: true })
    }
  },
  gamestate_reset_next(
    { state, getters, commit, dispatch },
    { pot = false, betInPot = false, board = false, player = false } = {},
  ) {
    commit('gamestate_set', { key: 'gamestate_next_pot', value: pot })
    commit('gamestate_set', { key: 'gamestate_next_board', value: board })
    commit('gamestate_set', { key: 'gamestate_next_player', value: player })
    commit('gamestate_set', { key: 'gamestate_betinpot', value: betInPot })

    if (
      !state.gamestate_namespace ||
      [
        'primary', //
        'secondary',
        'solfigr',
        namespaces.STUDY,
        namespaces.REPORTS,
      ].includes(state.gamestate_namespace)
    ) {
      return
    }
    dispatch(`anim_player_reset`)
  },
  gamestate_get_hero_actions(
    { state, getters, commit, dispatch },
    { namespace, waitForActionTrack = false, history_spot },
  ) {
    commit('trainer_set', { key: 'trainer_result_visible', value: false })
    let continueFn = null

    const l_practice_hand_id = getters.trainer_practice_hand_id
    if (waitForActionTrack) {
      continueFn = async () => {
        const actionTracking = heroActionTracked[namespace]
        if (actionTracking?.status === 'tracking') {
          // debugger
          await sleep(10)
          continueFn()
          return
        }
        if (actionTracking?.status === 'error') {
          return
        }
        // if (l_practice_hand_id !== getters.trainer_practice_hand_id) {
        if (stopGame(getters, l_practice_hand_id)) {
          // stop game in midst of animation timeouts - maybe would be better to
          console.log('killed gamestate_get_hero_actions handIdmismatch')
          return
        }
        dispatch('api_practice', { namespace }, { root: true })
      }
    } else {
      continueFn = () => {
        // if (l_practice_hand_id !== getters.trainer_practice_hand_id) {
        if (stopGame(getters, l_practice_hand_id)) {
          console.log('killed gamestate_get_hero_actions handIdmismatch')
          return
        }
        dispatch('api_practice', { namespace }, { root: true })
      }
    }

    dispatch('gamestate_animate_and_continue', { continueFn, isHero: true, history_spot })
  },
  gamestate_get_bot_action(
    { state, getters, commit, dispatch },
    { namespace, position, waitForActionTrack = false, history_spot },
  ) {
    const callTimeConf = { position, startTime: Date.now() }
    let continueFn = null

    const l_practice_hand_id = getters.trainer_practice_hand_id
    if (waitForActionTrack) {
      continueFn = async () => {
        const actionTracking = heroActionTracked[namespace]
        if (actionTracking?.status === 'tracking') {
          // debugger
          await sleep(10)
          continueFn()
          return
        }
        if (actionTracking?.status === 'error') {
          return
        }
        // stop game in midst of animation timeouts
        // if (l_practice_hand_id !== getters.trainer_practice_hand_id) {
        if (stopGame(getters, l_practice_hand_id)) {
          console.log('killed gamestate_get_bot_action handIdmismatch')
          return
        }
        dispatch('api_practice_bot_action', { namespace, callTimeConf }, { root: true })
      }
    } else {
      continueFn = () => {
        // if (l_practice_hand_id !== getters.trainer_practice_hand_id) {
        if (stopGame(getters, l_practice_hand_id)) {
          console.log('killed gamestate_get_bot_action handIdmismatch')
          return
        }
        dispatch('api_practice_bot_action', { namespace, callTimeConf }, { root: true })
      }
    }

    dispatch('gamestate_animate_and_continue', { continueFn, history_spot })
  },
  gamestate_set_api_practice_silent({ state, getters, commit, dispatch }, result) {
    if (result?.response?.status !== 200) {
      dispatch(
        `hands_handle_error`,
        { handler: 'practice_silent', result, namespace: state.gamestate_namespace },
        { root: true },
      )
    } else {
      // if (result.trainer_practice_hand_id !== getters.trainer_practice_hand_id) {
      if (stopGame(getters, result.trainer_practice_hand_id)) {
        console.log('killed gamestate_set_api_practice_silent handIdmismatch')
        return
      }

      const data = result.response?.data
      if (data?.warning) {
        dispatch('messages_custom', { id: 'message_zero_frequency_line' }, { root: true })
      }

      const { history_spot, actionWithoutPracticeId } = result
      const { history_spots } = getEventsPracticeSpecificSpotApi({
        api_practice: data,
        history_spots: state.history_spots,
        history_spot,
      })
      commit('gamestate_set', {
        key: 'history_spots',
        value: history_spots,
      })
      if (actionWithoutPracticeId) {
        const { available_actions } = getters
        // console.log(available_actions, actionWithoutPracticeId)
        let actionWithApiId = available_actions.find(aa => aa.code === actionWithoutPracticeId.code)
        if (!actionWithApiId) {
          actionWithApiId = available_actions.find(aa => aa.type === actionWithoutPracticeId.type)
          actionWithApiId = actionWithApiId || available_actions[0]
          console.error('error-trainer -- failed hero refetch', 'no-such-action')
        }

        dispatch('gamestate_track_action', {
          namespace: state.gamestate_namespace,
          action: actionWithApiId,
        })
      }
    }
  },
  gamestate_set_api_practice_bot_silent({ state, getters, commit, dispatch }, result) {
    if (result?.response?.status !== 200) {
      dispatch(
        `hands_handle_error`,
        { handler: 'practice_bot_silent', result, namespace: state.gamestate_namespace },
        { root: true },
      )
    } else {
      // if (result.trainer_practice_hand_id !== getters.trainer_practice_hand_id) {
      if (stopGame(getters, result.trainer_practice_hand_id)) {
        console.log('killed gamestate_set_api_practice_bot_silent handIdmismatch')
        return
      }

      const data = result.response?.data
      const { history_spot: hSpot } = result
      const { history_spots: hh } = getters
      const hSpotsBefore = hh.filter(e => e.id < hSpot.id)
      const hSpotsAfter = hh.filter(e => e.id > hSpot.id)

      const { selected_action_code } = hSpot

      // so its like api_practice_bot
      const mutatedData = {
        game: data.game,
        actions: data.available_actions.map(aa => {
          const r = {
            ...aa,
            selected: aa.action.code === selected_action_code,
            next_position: aa.action.next_position,
          }
          return r
        }),
      }

      const { history_spots } = getEventsPracticeBotApi({
        // api_practice_bot: data,
        api_practice_bot: mutatedData,
        history_spots: hSpotsBefore,
      })

      let hSpots = [...history_spots, ...hSpotsAfter]
      const { history_spot } = getters
      hSpots = hSpots.map(i => ({ ...i, is_active: i.id === history_spot.id }))
      commit('gamestate_set', {
        key: 'history_spots',
        value: hSpots,
      })
    }
  },
}

export default actions
